import ProjectTable from '../../components/projectTable';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import McListTableRow from '../../components/mcListTableRow';
import { ReactComponent as PendingIcon } from '../../../assets/svg/pending.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as CriticalP } from '../../../assets/svg/critical_priority.svg';
import { ReactComponent as HighP } from '../../../assets/svg/high_priority.svg';
import { ReactComponent as LowP } from '../../../assets/svg/low_priority.svg';
import { ReactComponent as MediumP } from '../../../assets/svg/medium_priority.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _, { times } from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { gql } from '@apollo/client';
import moment from 'moment';
import EditTask from '../../components/tasks/editTask';
import CreateTask from '../../components/tasks/createTask';
import { Space } from 'antd';
import LabelCard from '../Deliverables/LabelCard';
const getTaskFlags = gql`
	query TaskDefaultFilters($filters: TaskDefaultFiltersInput) {
		taskDefaultFilters(filters: $filters) {
			all
			overdue
			statusFilters {
				status
				count
			}
			unassigned
			unscheduled
		}
	}
`;
const getProjects = gql`
	query VendorsProjects($filters: projectsListFiltersInput, $workspaceIds: [String!]) {
		vendorsProjects(filters: $filters, workspaceIds: $workspaceIds) {
			data {
				id
				title
				events {
					date
				}
				hardDrives {
					size
				}
				collaborators {
					designations
					tenantUserId
				}
				firstEvent {
					date
					name
				}
				lastEvent {
					date
					name
				}
				weddingEvent {
					date
					name
				}
				tenantId
				slNo
			}
			currentPage
			hasNextPage
			hasPrevPage
			nextPage

			totalPages
			limit
			prevPage
		}
	}
`;
const getTaskList = gql`
	query Data($filters: TaskFilters!) {
		tasks(filters: $filters) {
			data {
				assignedAt
				projectId
				scopeName
				projectTitle
				assignedBy {
					id
					name
				}
				assignedTo {
					id
					name
				}

				createdAt
				createdBy
				status
				priority
				deletedBy
				dueDate
				id
				logs {
					_id
					action

					createdAt
					changeLogs {
						from {
							assignedTo {
								id
								name
							}
							status
							dueDate
							title
						}
						to {
							assignedTo {
								id
								name
							}
							status
							dueDate
							title
						}
					}
				}
				notes {
					_id
					message
					files
					createdBy
					createdAt
					updatedBy
					updatedAt
				}
				projectId
				scope
				scopeId

				taskId
				tenantId
				title
				updatedAt
				updatedBy
			}
			currentPage
			hasPrevPage
			hasNextPage
			limit
			nextPage
			prevPage
			totalDocs
			totalPages
		}
	}
`;
const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName

			displayName
		}
	}
`;
const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;
class Tasks extends ProjectsGraphQlController {
	constructor() {
		super();

		this.state = {
			isLoading: true,
			limit: 20,
			activeFlag: '',
			doneCount: 0,
			projectsList: [],
			taskFlags: null,
			statusFlags: null,
			page: 1,
			search: '',
			namesList: [],
			lengthOfList: 0,
			assignedToActiveFilter: [],
			assignedToFilters: null,
			scopeActiveFilter: '',
			showEditTaskModal: false,
			showCreateTaskModal: false,

			currentViewPage: 1,

			workspaceActiveFilter: [],
			workspacesFilters: [],
			taskList: [],
			modalData: {},
			columns: [
				// { title: 'FLAG' },
				{ title: 'TASK ID' },
				{ title: 'DESCRIPTION' },
				{ title: 'SCOPE' },
				{ title: 'STATUS' },
				{ title: 'PRIORITY' },
				{ title: 'ASSIGNED TO' },
				{ title: 'DUE DATE' },
				{ title: 'LAST UPDATED BY' },
			],
			scopeFilters: [
				{ key: 'general', name: 'General' },
				// { key: 'workspace', name: 'Workspace' },
				{ key: 'deliverable', name: 'Deliverable' },
				{ key: 'workspace', name: 'Workspace' },
				{ key: 'project', name: 'Project' },
			],
		};
	}
	getWorkspacename = (id) => {
		if (this.state.workspacesFilters.length > 0) {
			for (let i = 0; i < _.size(this.state.workspacesFilters); i++) {
				if (this.state.workspacesFilters[i].key === id)
					return this.state.workspacesFilters[i].name;
			}
		}

		return '';
	};
	getProjectTitleName = (id) => {
		if (this.state.projectsList.length > 0) {
			for (let i = 0; i < _.size(this.state.projectsList); i++) {
				if (this.state.projectsList[i].id === id) {
					return this.state.projectsList[i].title;
				}
			}
		}

		return '';
	};
	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				taskList: [],
				isPageLoading: true,
			},
			() => {
				this.fetchMoreTasks();
			},
		);
	};

	componentDidMount = () => {
		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'assignedTo') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'scope') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'tenantId') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'search') {
					json = {
						...json,
						filters: {
							...json.filters,

							[subString[0]]: subString[1],
						},
					};
				}
				if (subString[0] && subString[0] === 'activeFlag') {
					json = {
						...json,
						filters: {
							...json.filters,

							statusFilters: subString[1],
						},
					};
				}

				if (subString[0] === 'page' || subString[0] === 'limit') {
					if (subString[0] === 'page') {
						this.setState({
							currentViewPage: parseInt(subString[1]),
						});
					} else {
						this.setState({
							[subString[0]]: parseInt(subString[1]),
						});
					}
				}
				if (subString[0] && subString[0] === 'assignedTo') {
					this.setState({
						[`${subString[0]}ActiveFilter`]: subString[1].split(','),
					});
				}
				if (subString[0] && subString[0] === 'scope') {
					this.setState({
						[`${subString[0]}ActiveFilter`]: subString[1],
					});
				}
				if (subString[0] && subString[0] === 'tenantId') {
					this.setState({
						workspaceActiveFilter: subString[1].split(','),
					});
				}
				if (subString[0] && subString[0] === 'search') {
					this.setState({
						[subString[0]]: subString[1],
					});
				}
				if (subString[0] && subString[0] === 'activeFlag') {
					this.setState({
						[subString[0]]: subString[1],
					});
				}
				count++;
			}
		} else {
			json = {
				filters: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
				},
			};
		}

		this.getTaskList(getTaskList, json);
		this.getTenantUsers(getTenantUserList);
		// this.getProjectsList2(getProjects, {
		// 	filters: {
		// 		limit: 1000,
		// 		page: 1,
		// 	},
		// });
		this.getVendorsWorkspaces(getVendorInfo, {
			vendorId: this.props.params.vendorID,
		});
		this.getTaskFlags(getTaskFlags);
		// this.getTenantUsers(getTenantUserList);
	};
	showEditTaskModal = (
		id,
		taskId,
		tenantId,
		projectId,
		title,
		assignedTo,
		dueDate,
		priority,
		status,
		notes,
		scope,
		scopeName,
		projectTitle,
	) => {
		this.setState({
			showEditTaskModal: !this.state.showEditTaskModal,
			modalData: {
				id: id,
				taskId:
					scope === 'general'
						? '*' + taskId.toString()
						: this.getWorkSpaceKeyName(tenantId) + '-' + taskId.toString(),
				workspaceName: this.getWorkspacename(tenantId),
				projectName: this.getProjectTitleName(projectId),
				description: title,
				assignedTo: assignedTo ? { value: assignedTo.id, label: assignedTo.name } : null,
				dueDate: dueDate,
				priority: priority,
				status: status,
				notes: notes,
				messageNotes:
					notes !== null && notes.length > 0
						? notes.map((el) => {
								return { message: el.message };
						  })
						: null,
				scope: scope,
				scopeName: scopeName,
				projectTitle: projectTitle,
			},
		});
		// alert(status);
	};
	showCreateTaskModal = () => {
		this.setState({
			showCreateTaskModal: !this.state.showCreateTaskModal,
		});
	};
	getAssignedToName = (assignedId) => {
		if (this.state.tenantUserList.length !== 0) {
			for (let i = 0; i < this.state.tenantUserList.length; i++) {
				if (this.state.tenantUserList[i].id === assignedId) {
					return (
						this.state.tenantUserList[i].firstName +
						' ' +
						this.state.tenantUserList[i].lastName
					);
				}
			}
		}

		return 'Unknown';
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreTasks();
				},
			);
		}
	};

	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreTasks();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreTasks();
				},
			);
		}
	};
	fetchMoreTasks = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;
		if (this.state.assignedToActiveFilter.length !== 0)
			queryString = `${queryString}&assignedTo=${this.state.assignedToActiveFilter.toString()}`;
		if (this.state.scopeActiveFilter.length !== 0)
			queryString = `${queryString}&scope=${this.state.scopeActiveFilter}`;
		if (this.state.workspaceActiveFilter.length !== 0)
			queryString = `${queryString}&tenantId=${this.state.workspaceActiveFilter.toString()}`;
		if (this.state.search.length !== 0)
			queryString = `${queryString}&search=${this.state.search.toString()}`;
		if (this.state.activeFlag.length !== 0)
			queryString = `${queryString}&activeFlag=${this.state.activeFlag.toString()}`;
		this.props.navigate(`/${this.props.params.vendorID}/tasks${queryString}`);

		let filters = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
			},
		};
		let json = {};
		if (this.state.assignedToActiveFilter.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					assignedTo: this.state.assignedToActiveFilter,
				},
			};
			json = {
				...json,
				filters: {
					...json.filters,
					assignedTo: this.state.assignedToActiveFilter,
				},
			};
		}
		if (this.state.scopeActiveFilter.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					scope: this.state.scopeActiveFilter,
				},
			};
			json = {
				...json,
				filters: {
					...json.filters,
					scope: this.state.scopeActiveFilter,
				},
			};
		}
		if (this.state.workspaceActiveFilter.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					tenantId: this.state.workspaceActiveFilter,
				},
			};
			json = {
				...json,
				filters: {
					...json.filters,
					tenantId: this.state.workspaceActiveFilter,
				},
			};
		}
		if (this.state.search.length !== 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					search: this.state.search,
				},
			};
			json = {
				...json,
				filters: {
					...json.filters,
					search: this.state.search,
				},
			};
		}
		if (this.state.activeFlag !== '' && this.state.activeFlag.length > 0) {
			filters = {
				...filters,
				filters: {
					...filters.filters,
					statusFilters: this.state.activeFlag,
				},
			};
		}
		this.setState({
			isLoading: true,
		});
		console.log('debugging filters for task flags--->', json);
		this.getTaskFlags(getTaskFlags, json);
		await this.getTaskList(getTaskList, filters);
	};
	getWorkSpaceKeyName = (id) => {
		if (this.state.workspacesFilters.length > 0) {
			for (let i = 0; i < _.size(this.state.workspacesFilters); i++) {
				if (this.state.workspacesFilters[i].key === id) {
					return this.state.workspacesFilters[i].workspaceKey;
				}
			}
		}
		return '';
	};
	handleActiveFilter = (e, type, key) => {
		let array;
		if (type === 'project' || type === 'status') {
			array = this.state[`${type}ActiveFilter`] === key ? '' : key;
		} else {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
			},
			() => this.fetchMoreShoots(),
		);
	};

	goToShoot = (e, workspaceID, projectID, shootID, newTab = false) => {
		localStorage.setItem('lastViewedShootID', shootID);
		let workspace;
		workspace = _.filter(this.state.associatedTenants, {
			_id: workspaceID,
		})[0].workspaceId;
		if (workspace) {
			let url = `/${this.props.params.vendorID}/shoots/${workspace}/${projectID}/${shootID}`;
			if (newTab) {
				window.open(url);
			} else this.props.navigate(url);
		}
	};

	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: [],
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
			},
			() => {
				this.fetchMoreTasks();
			},
		);
	};
	handleFlag = async (code) => [
		this.setState(
			{
				activeFlag: this.state.activeFlag === code ? '' : code,
			},
			async () => {
				await this.fetchMoreTasks();
			},
		),
	];
	render() {
		const sortedTaskList = [...this.state.taskList].sort((a, b) => {
			// Convert null dueDate values to be treated as a later date than any valid date
			const dueDateA = a.dueDate
				? moment(a.dueDate, 'YYYYMMDD')
				: moment('99991231', 'YYYYMMDD');
			const dueDateB = b.dueDate
				? moment(b.dueDate, 'YYYYMMDD')
				: moment('99991231', 'YYYYMMDD');

			// Compare the dueDate values for sorting
			return dueDateA - dueDateB;
		});

		return (
			<div className="layout-wrapper">
				{this.state.isLoading ||
				this.state.taskFlags === null ||
				this.state.statusFlags === null ||
				this.state.assignedToFilters === null ? (
					<>
						<LoadingBar />
					</>
				) : (
					<div className="container">
						<div className="searchContainer">
							<div className="shoots-header-filters-container">
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									version="v2"
									filters={this.state.workspacesFilters}
									activeFilter={this.state.workspaceActiveFilter}
									// handleActiveFilter={(e, status, key) =>
									// 	this.handleActiveFilter(e, 'workspace', key)
									// }
									clearSelection={(e) =>
										this.handleclearSelection(e, 'workspace')
									}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'assignedTo'}
									label={'Assigned To'}
									version="v2"
									filters={this.state.assignedToFilters}
									activeFilter={this.state.assignedToActiveFilter}
									// handleActiveFilter={(e, status, key) =>
									// 	this.handleActiveFilter(e, 'workspace', key)
									// }
									clearSelection={(e) =>
										this.handleclearSelection(e, 'assignedTo')
									}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'scope'}
									label={'Scope'}
									version="v2"
									filters={this.state.scopeFilters}
									activeFilter={this.state.scopeActiveFilter}
									clearSelection={(e) => this.handleclearSelection(e, 'scope')}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									gap: '10px',
								}}
							>
								<div className="searchWrapper">
									<div className="search-inner-left">
										<span className="search-icon">
											<SearchIcon />
										</span>
										<input
											placeholder="Search"
											value={this.state.search}
											onChange={(e) => {
												this.setState({
													search: e.target.value,
												});
											}}
										/>
									</div>
									<div className="search-inner-right">
										<span className="search-dropdown-btn">
											<a
												className="search-type"
												onClick={(e) => {
													this.fetchMoreTasks();
												}}
											>
												Search
											</a>
										</span>
									</div>
								</div>
								<div
									className="create-shoot-btn"
									onClick={(e) => this.showCreateTaskModal()}
								>
									+ Create Task
								</div>
							</div>
						</div>

						<div className="filters">
							<div className="projects-table-outer-container">
								<Space size={[8, 0]} wrap>
									<span onClick={() => this.handleFlag('all')}>
										<LabelCard
											info={
												this.state.taskFlags.all
													? this.state.taskFlags.all
													: 0
											}
											data={'All'}
											checkbox={false}
											// checkColor={el.color}
											bgColor={
												this.state.activeFlag === 'all' ? '#6055EC' : ''
											}
										/>
									</span>

									<span onClick={() => this.handleFlag('pending')}>
										<LabelCard
											info={_.sumBy(
												_.filter(
													this.state.statusFlags,
													(obj) => obj.status !== 'done',
												),
												'count',
											)}
											data={'Pending'}
											checkbox={false}
											// checkColor={el.color}
											bgColor={
												this.state.activeFlag === 'pending' ? '#6055EC' : ''
											}
										/>
									</span>
								</Space>
								<span style={{ marginLeft: '20px' }}></span>
								<Space size={[8, 0]} wrap>
									{this.state.statusFlags.length > 0 ? (
										<>
											{this.state.statusFlags.map((el) => {
												return (
													<span
														onClick={() => this.handleFlag(el.status)}
													>
														<LabelCard
															info={el.count}
															data={
																el.status === 'todo'
																	? 'To Do'
																	: el.status
																			.match(
																				/[A-Z][a-z]*|[a-z]+/g,
																			)
																			.map(
																				(word) =>
																					word
																						.charAt(0)
																						.toUpperCase() +
																					word.slice(1),
																			)
																			.join(' ')
															}
															checkbox={true}
															checkColor={el.color}
															bgColor={
																this.state.activeFlag === el.status
																	? '#6055EC'
																	: ''
															}
														/>
													</span>
												);
											})}
										</>
									) : (
										<></>
									)}
									<Space />
									<span style={{ marginLeft: '12px' }}></span>
									<Space size={[8, 0]} wrap></Space>
									<span onClick={() => this.handleFlag('unassigned')}>
										<LabelCard
											info={
												this.state.taskFlags.unassigned
													? this.state.taskFlags.unassigned
													: 0
											}
											data={'Unassigned'}
											checkbox={false}
											// checkColor={el.color}
											bgColor={
												this.state.activeFlag === 'unassigned'
													? '#6055EC'
													: ''
											}
										/>
									</span>
									<span onClick={() => this.handleFlag('unscheduled')}>
										<LabelCard
											info={
												this.state.taskFlags.unscheduled
													? this.state.taskFlags.unscheduled
													: 0
											}
											data={'Due date TBD'}
											checkbox={false}
											// checkColor={el.color}
											bgColor={
												this.state.activeFlag === 'unscheduled'
													? '#6055EC'
													: ''
											}
										/>
									</span>
									<span onClick={() => this.handleFlag('overdue')}>
										<LabelCard
											info={
												this.state.taskFlags.overdue
													? this.state.taskFlags.overdue
													: 0
											}
											text="#CA5A4F"
											data={'Overdue'}
											checkbox={false}
											// checkColor={el.color}
											bgColor={
												this.state.activeFlag === 'overdue' ? '#6055EC' : ''
											}
										/>
									</span>
								</Space>
							</div>
						</div>
						<div className={'table project-table-list'}>
							{this.state.taskList.length != 0 && (
								<ProjectTable
									ptProps="yes"
									tableHeaderLeftPad={35}
									isLoading={this.state.isLoading}
									tableHeader={`SHOOTS`}
									columns={this.state.columns}
									// activeSortType={this.state.sortType}
									// activeSortBy={this.state.sortBy}
									// handleSort={this.handleProjectSort}
									// isPageLoading={this.state.isPageLoading}
									limit={this.state.limit}
									totalPages={this.state.totalPages}
									currentViewPage={this.state.currentViewPage}
									lengthOfList={this.state.lengthOfList}
									onClickNextPage={this.onClickNextPage}
									onClickPreviousPage={this.onClickPreviousPage}
									dataList={this.state.taskList}
									goToPage={(e) => this.handleGoToPage(e)}
									module={'project'}
									searchQuery={''}
									mainFilter={''}
								>
									{this.state.taskList.length > 0 &&
										_.map(sortedTaskList, (task, index) => {
											return (
												<tr
													style={{
														backgroundColor:
															task.dueDate &&
															moment(
																task.dueDate,
																'YYYYMMDD',
															).isBefore(moment(), 'day') &&
															task.status !== 'done'
																? '#271713'
																: task.status === 'done'
																? '#17201A'
																: '',
													}}
													onClick={() => {
														this.showEditTaskModal(
															task.id,
															task.taskId,
															task.tenantId,
															task.projectId,
															task.title,
															task.assignedTo,
															task.dueDate ? task.dueDate : null,
															task.priority,
															task.status,
															task.notes,
															task.scope,
															task.scopeName,
															task.projectTitle,
														);
													}}
												>
													<td
														className="all-other-column-fixed"
														style={{
															borderLeft: '0.4px solid #383838',
															color: '#E4E5E6',
															fontSize: '12px',
															fontWeight: '500',
															textAlign: 'center',
														}}
													>
														{/* <div
														className="project-general-box"
														style={{
															color: '#E4E5E6',
															fontSize: '12px',
															fontWeight: '500',
														}}
													> */}
														{task.scope === 'general'
															? '*' + task.taskId
															: this.getWorkSpaceKeyName(
																	task.tenantId,
															  ) +
															  '-' +
															  task.taskId}
														{/* </div> */}
													</td>
													<td className="all-other-column-fixed">
														<div
															className="project-general-box"
															style={{
																color: '#E4E5E6',
																textTransform: 'capitalize',
																fontSize: '12px',
																fontWeight: '500',
															}}
														>
															{task.title}
														</div>
													</td>
													<td className="all-other-column-fixed">
														<div
															className="project-general-box"
															style={{
																color: 'black',
																textTransform: 'capitalize',
																fontSize: '12px',
																fontWeight: '500',
															}}
														>
															<div className="scope-cell-parent">
																<div className="scope-cell">
																	<p
																		style={{
																			padding: '4px 6px',
																			backgroundColor:
																				task.scope ===
																				'general'
																					? '#FDB946'
																					: '#fff',
																			borderRadius: '4px',
																		}}
																	>
																		{task.scope}
																	</p>

																	{task.scopeName &&
																		task.scope !==
																			'project' && (
																			<p
																				style={{
																					padding:
																						'4px 6px',
																					backgroundColor:
																						'rgba(255, 255, 255, 0.10)',
																					borderRadius:
																						'4px',
																					color: '#E4E5E6',
																					maxWidth:
																						'100px',
																					overflow:
																						'hidden',
																					whiteSpace:
																						'nowrap',
																					textOverflow:
																						'ellipsis',
																				}}
																			>
																				{task.scopeName}
																			</p>
																		)}
																</div>
																{task.projectTitle && (
																	<p
																		style={{
																			padding: '4px 6px',
																			backgroundColor:
																				'rgba(255, 255, 255, 0.10)',
																			borderRadius: '4px',
																			color: '#E4E5E6',
																		}}
																	>
																		{task.projectTitle}
																	</p>
																)}
															</div>
														</div>
													</td>
													<td className="all-other-column-fixed">
														<div className="project-general-box">
															<span
																className={`completed-shoots `}
																style={{
																	// marginTop: '-120px',

																	display: 'flex',
																	// justifyContent: 'flex-start',
																	alignItems: 'center',
																	textTransform: 'uppercase',
																	fontSize: '14px',
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																<b
																	style={{
																		width: '10px',
																		height: '10px',
																		minHeight: '10px',
																		minWidth: '10px',
																		borderRadius: '2px',

																		backgroundColor:
																			task.status === 'todo'
																				? '#9F4DB7'
																				: task.status ===
																				  'inReview'
																				? '#8EE2C7'
																				: task.status ===
																				  'done'
																				? '#479A5F'
																				: '#03A0FF',
																		marginRight: 5,
																		display: 'flex',
																	}}
																></b>
																{task.status === 'todo'
																	? 'To Do'
																	: task.status === 'inReview'
																	? 'IN REVIEW'
																	: task.status === 'done'
																	? 'DONE'
																	: 'IN PROGRESS'}
															</span>
														</div>
													</td>
													<td
														className="all-other-column-fixed"
														style={{
															textAlign: 'center',
														}}
													>
														{task.priority === 'critical' ? (
															<CriticalP />
														) : task.priority === 'high' ? (
															<HighP />
														) : task.priority === 'medium' ? (
															<MediumP />
														) : task.priority === 'low' ? (
															<LowP />
														) : (
															''
														)}
													</td>
													<td className="all-other-column-fixed">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																color: 'white',
																textTransform: 'capitalize',
															}}
														>
															<p
																style={{
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																{task.assignedTo
																	? task.assignedTo.name
																	: ''}
															</p>
															<p
																style={{
																	color: '#707070',
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																{task.assignedAt
																	? moment
																			.unix(task.assignedAt)
																			.fromNow()
																	: ''}
																{/* time ago */}
															</p>
														</div>
													</td>
													<td className="all-other-column-fixed">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																color:
																	moment(
																		task.dueDate,
																		'YYYYMMDD',
																	).isBefore(moment(), 'day') &&
																	task.status !== 'done'
																		? '#F8532B'
																		: 'white',
																textTransform: 'capitalize',
															}}
														>
															<p
																style={{
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																{task.dueDate
																	? moment(
																			task.dueDate,
																			'YYYYMMDD',
																	  ).format('DD MMM YYYY')
																	: ''}
															</p>
															<p
																style={{
																	color:
																		moment(
																			task.dueDate,
																			'YYYYMMDD',
																		).isBefore(
																			moment(),
																			'day',
																		) && task.status !== 'done'
																			? '#F8532B'
																			: '#707070',
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																{task.dueDate
																	? moment(
																			task.dueDate,
																			'YYYYMMDD',
																	  ).fromNow()
																	: ''}
															</p>
														</div>
													</td>
													<td className="all-other-column-fixed">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																gap: '8px',
																color: 'white',
																textTransform: 'capitalize',
															}}
														>
															<p
																style={{
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																{this.state.tenantUserList &&
																	this.state.tenantUserList
																		.length > 0 &&
																	this.getAssignedToName(
																		task.updatedBy,
																	)}
															</p>
															<p
																style={{
																	color: '#707070',
																	fontSize: '12px',
																	fontWeight: '500',
																}}
															>
																{moment
																	.unix(task.updatedAt)
																	.fromNow()}
															</p>
														</div>
													</td>
												</tr>
											);
										})}
								</ProjectTable>
							)}

							{this.state.taskList.length === 0 && (
								<div
									style={{
										width: '100%',
										padding: '20px',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<p className="no-tasks-text">No Tasks Found</p>
								</div>
							)}
						</div>
					</div>
				)}
				{this.state.showEditTaskModal === true ? (
					<EditTask
						handleClose={() => {
							this.setState({
								showEditTaskModal: false,
							});
							this.fetchMoreTasks();
							this.getTaskFlags(getTaskFlags);
						}}
						modalData={this.state.modalData}
						assignedToOptions={this.state.namesList2}
						// assignedToOptions={this.state.assignedToOptions}
						show={this.state.showEditTaskModal}
						custClass={'modal-with-no-fixed-height'}

						// branchesOptions={this.state.branchesOptions}
					/>
				) : null}
				{this.state.showCreateTaskModal === true ? (
					<CreateTask
						handleClose={() => {
							this.setState({
								showCreateTaskModal: false,
							});
							this.fetchMoreTasks();
							this.getTaskFlags(getTaskFlags);
						}}
						workspacesOptions={this.state.workspaceOptions}
						assignedToOptions={this.state.namesList2}
						show={this.state.showCreateTaskModal}
						custClass={'modal-with-no-fixed-height'}
					/>
				) : null}
			</div>
		);
	}
}

export default withRouter(Tasks);
